<template>

	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div>

		<div class="main">
			<div class="main_title">
				<span>检测工具及设备</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="payment_info el-table">
					<el-table :data="TestFrom" border>
						<el-table-column label="设备名称" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.test_name"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="品牌（厂家）" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.test_brand"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="台数" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.test_num"
									oninput="value=value.replace(/[^\d]/g,'')">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="购置时间" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-date-picker v-model="scope.row.test_time" type="year" placeholder="选择年"
									value-format="yyyy">
								</el-date-picker>
								<!--          <el-date-picker v-model="scope.row.test_time" type="date"  placeholder="选择日期"-->
								<!--                          format="yyyy"-->
								<!--                          value-format="yyyy"-->
								<!--          ></el-date-picker>-->
							</template>
						</el-table-column>
						<el-table-column label="适用检测范围" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.test_use"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="keyId" v-if="false">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.keyid"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.$index,scope.row.keyid)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>


				</div>
				<div class="payment_info_button">
					<button type="button" @click="addLine"><span>新增行</span></button>
					<button type="button" @click="openMain()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff" @click="addTest()"><span>保存</span></button>
					<button type="button" @click="nextMateLine()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getGys,
		addTest,
		delTest,
		getTest
	} from '../api/LoginApi'
	import {
		goBack,
		Transformation
	} from '../utils/Transformation'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'

	export default {
		name: 'GysTestLine',
		data() {
			return {
				TestFrom: [{
					gys_no: localStorage.getItem('userName'),
					test_name: '',
					test_brand: '',
					test_num: '',
					test_time: '',
					test_use: '',
					keyid: 0,
					show: true
				}]
			}
		},
		created() {
			this.getTest()
		},
		mounted() {
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {
			 // 给表头加必填符号*
			addRedStar(h, { column }) {
				return [
					h("span", { style: "color: red" }, "*"),
					h("span", " " + column.label),
				];
			},
			// 查询数据
			getTest() {
				getTest(localStorage.getItem('userName')).then(res => {
					if (res.length > 0) {
						this.TestFrom = res
						// console.log('检测工具及设备', res)
					}
					//获取单据状态
					getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							this.TestFrom.bill_status = res.bill_status;
						}
					});
				})
			},
			// 上一个页面
			openMain() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			// 下一个页面
			nextMateLine() {
				if (this.TestFrom.bill_status != '已审核') { 
					//保存数据
					this.addTest();
					const vm = this;
					if(this.TestFrom.length > 0){
						for(var i = 0; i < this.TestFrom.length; i++){
							var item = this.TestFrom[i];
							// if (item.test_name){
								if (!item.test_name){
									return messageError('第'+(i+1)+'行[设备名称]不能为空!');
								}
								if (!item.test_brand){
									return messageError('第'+(i+1)+'行[品牌（厂家）]不能为空!');
								}
								if (!item.test_num){
									return messageError('第'+(i+1)+'行[台数]不能为空!');
								}
								if (!item.test_time){
									return messageError('第'+(i+1)+'行[购置时间]不能为空!');
								}
								if (!item.test_use){
									return messageError('第'+(i+1)+'行[适用检测范围]不能为空!');
								}
							// }
						}
					}
				}
				const vm = this;
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity '
				})
			},
			// 保存数据
			addTest: function() {
				if (this.TestFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if(this.TestFrom.length > 0){
						for(var i = 0; i < this.TestFrom.length; i++){
							var item = this.TestFrom[i];
							// if (item.test_name){
								if (!item.test_name){
									return messageError('第'+(i+1)+'行[设备名称]不能为空!');
								}
								if (!item.test_brand){
									return messageError('第'+(i+1)+'行[品牌（厂家）]不能为空!');
								}
								if (!item.test_num){
									return messageError('第'+(i+1)+'行[台数]不能为空!');
								}
								if (!item.test_time){
									return messageError('第'+(i+1)+'行[购置时间]不能为空!');
								}
								if (!item.test_use){
									return messageError('第'+(i+1)+'行[适用检测范围]不能为空!');
								}
							// }
						}
				}

				addTest(this.TestFrom, localStorage.getItem('userName')).then(res => {
					if (res.code === 200) {
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			},
			// 删除行，删除数据
			handleDelete: function(index, keyId) { // 删除行数
				if (this.TestFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if (keyId) {
					delTest(keyId).then(res => {
						if (res.code === 200) {
							return messageSuCcEss(res.msg)
						} else {
							return messageError(res.msg)
						}
					})
				}
				this.TestFrom.splice(index, 1)
			},
			// 新增行
			addLine: function() {
				if (this.TestFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				let RateValue = {
					gys_no: localStorage.getItem('userName'),
					test_name: '',
					test_brand: '',
					test_num: '',
					test_time: '',
					test_use: '',
					keyid: 0,
					show: true
				}
				this.TestFrom.push(RateValue)
			}
		}
	}
</script>


<style scoped>
	@import "../css/Main.css";
</style>



// WEBPACK FOOTER //
// src/componentsline/GysTestLine.vue